export default __webpack_public_path__ + "static/media/1.446b6d86.png";